import React from "react";
import { TICKET_STATUSES } from "../landingData";
import { TICKET_PRIORITY_OPTIONS, TICKET_STATUS_OPTIONS } from "../mockup/mockData";

const DEMO_TICKET = {
    title: "Refund for order #1842",
    sub: "Hi team, I was charged twice…",
    ref: "#1842",
    status: "active",
    department: "Support",
    deptColor: "#92400e",
    priority: "medium",
    assigneeInitials: "CL",
    assigneeName: "Cole L.",
};

const DEMO_ACTIVITY = [
    {
        color: "#12a364",
        text: "Status changed to Active",
        time: "2 hours ago",
    },
    {
        color: "#0087e2",
        text: "Assigned to Cole L.",
        time: "3 hours ago",
    },
    {
        color: "#9ca3af",
        text: "Ticket created from email",
        time: "Yesterday",
    },
];

const statusOptions = TICKET_STATUS_OPTIONS.filter((option) => option.value);
const priorityOptions = TICKET_PRIORITY_OPTIONS;

const getStatusOption = (value) =>
    statusOptions.find((option) => option.value === value) || statusOptions[0];

const getPriorityOption = (value) =>
    priorityOptions.find((option) => option.value === value) || priorityOptions[0];

const hexToRgb = (hex) => {
    const normalized = hex.replace("#", "");
    const value = normalized.length === 3
        ? normalized.split("").map((c) => c + c).join("")
        : normalized;

    return {
        r: parseInt(value.slice(0, 2), 16),
        g: parseInt(value.slice(2, 4), 16),
        b: parseInt(value.slice(4, 6), 16),
    };
};

const tint = (hex, alpha = 0.12) => {
    const { r, g, b } = hexToRgb(hex);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const StatusTag = ({ color, label }) => (
    <li className="clk-st-tag">
        <span className="clk-st-tag-dot" style={{ background: color }} />
        <span>{label}</span>
    </li>
);

const StatusAssigneeTag = ({ initials, name }) => (
    <li className="clk-st-tag clk-st-tag--assignee">
        <span
            className="clk-st-tag-avatar"
            style={{ background: initials ? "#0087e2" : "#9ca3af" }}
        >
            {initials || "-"}
        </span>
        <span>{name || "Unassigned"}</span>
    </li>
);

const StatusSection = () => {
    const statusOption = getStatusOption(DEMO_TICKET.status);
    const priorityOption = getPriorityOption(DEMO_TICKET.priority);

    return (
        <section className="clk-section clk-section-statuses alt" id="statuses">
            <div className="clk-container">
                <div className="clk-status-layout">
                    <div className="clk-status-copy clk-reveal">
                        <span className="clk-eyebrow"><span className="clk-dot" /> Status tracking</span>
                        <h2>Know where every ticket stands.</h2>
                        <p>
                            Statuses move with each ticket, so the whole team reads the
                            queue at a glance.
                        </p>
                        <ul className="clk-status-list">
                            {TICKET_STATUSES.map((s) => (
                                <li key={s.id}>
                                    <span
                                        className="clk-status-dot"
                                        style={{ background: s.color }}
                                        aria-hidden="true"
                                    />
                                    {s.label}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="clk-status-table-wrap clk-reveal d2">
                        <div className="clk-status-mockup">
                            <article className="clk-st-card">
                                <div className="clk-st-card-inner">
                                    <div className="clk-st-card-top">
                                        <span
                                            className="clk-st-status"
                                            style={{
                                                color: statusOption.color,
                                                background: tint(statusOption.color),
                                            }}
                                        >
                                            <span
                                                className="clk-st-status-dot"
                                                style={{ background: statusOption.color }}
                                            />
                                            {statusOption.label}
                                        </span>
                                        <span className="clk-st-ref">{DEMO_TICKET.ref}</span>
                                    </div>

                                    <h3 className="clk-st-title">{DEMO_TICKET.title}</h3>
                                    <p className="clk-st-preview">{DEMO_TICKET.sub}</p>

                                    <ul className="clk-st-tags">
                                        <StatusTag
                                            color={DEMO_TICKET.deptColor}
                                            label={DEMO_TICKET.department}
                                        />
                                        <StatusTag
                                            color={priorityOption.color}
                                            label={priorityOption.label}
                                        />
                                        <StatusAssigneeTag
                                            initials={DEMO_TICKET.assigneeInitials}
                                            name={DEMO_TICKET.assigneeName}
                                        />
                                    </ul>

                                    <div className="clk-st-activity">
                                        <span className="clk-st-activity-label">Recent activity</span>
                                        <ul className="clk-st-activity-list">
                                            {DEMO_ACTIVITY.map((item) => (
                                                <li key={item.text} className="clk-st-activity-item">
                                                    <span
                                                        className="clk-st-activity-dot"
                                                        style={{ background: item.color }}
                                                        aria-hidden="true"
                                                    />
                                                    <span className="clk-st-activity-copy">
                                                        {item.text}
                                                        <span className="clk-st-activity-time">{item.time}</span>
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StatusSection;
